define([
  'react',
  'prop-types',
  'react-dom',
  'immutable',
  'underscore',
  'es6!sumo/util',
], (React, PropTypes, ReactDOM, Immutable, _, Util) => {
  class Autocomplete extends React.Component {
    static propTypes = {
      inputStyle: PropTypes.object,
      selectedIndex: PropTypes.number,
      suggestions: PropTypes.array,
      spellingSuggestions: PropTypes.array,
      getAllSuggestions: PropTypes.func,
      onSetIgnoreBlur: PropTypes.func,
      onCloseAutocomplete: PropTypes.func,
      onHoverSuggestion: PropTypes.func,
    };

    constructor(props) {
      super(props);

      this.onClose = this.onClose.bind(this);
    }

    onClose(suggestion) {
      const { onCloseAutocomplete, onSetIgnoreBlur } = this.props;
      if (!onCloseAutocomplete || !onSetIgnoreBlur) return;

      onSetIgnoreBlur();
      onCloseAutocomplete(suggestion);
    }

    renderUnderlay() {
      const {
        suggestions,
        inputStyle,
        selectedIndex,
        onAccommodateTypeahead,
        value,
        containerStyle,
        scrollLeft,
      } = this.props;

      if (!suggestions.length) return;
      if (inputStyle.textAlign === 'right') return;
      if (scrollLeft > 0) return;

      let underlayStyle = _.clone(inputStyle);

      // Adjust underlay for centered inputs
      if (underlayStyle.textAlign === 'center') {
        const cval = document.createElement('DIV');
        cval.innerHTML = escape(value);

        _.extend(cval.style, {
          position: 'absolute',
          left: '-100%',
          top: '-100%',
          fontFamily: underlayStyle.fontFamily,
          fontSize: underlayStyle.fontSize,
          fontStyle: underlayStyle.fontStyle,
          fontWeight: underlayStyle.fontWeight,
        });

        document.body.append(cval);

        const offsetLeft = Math.round(cval.offsetWidth / 2);
        const inputWidth = parseInt(containerStyle.width);

        underlayStyle = _.extend(underlayStyle, { paddingLeft: `${(inputWidth / 2) - offsetLeft - 1}px`, textAlign: 'left' });

        document.body.removeChild(cval);
      }

      const safeIndex = selectedIndex >= suggestions.length ? suggestions.length - 1 : selectedIndex;
      return (
        <input
          disabled
          className="sumome-autocomplete-underlay"
          type="text"
          style={{...underlayStyle}}
          spellCheck={false}
          value={suggestions[safeIndex || 0] || ''}
        />
      );
    }

    renderSuggestions() {
      const {
        inputStyle,
        selectedIndex,
        getAllSuggestions,
        onSetIgnoreBlur,
        onHoverSuggestion,
        showAboveInput,
      } = this.props;

      let allSuggestions = getAllSuggestions();
      if (!allSuggestions.length) return;

      let placeholderStyle = _.extend({}, {
        top: inputStyle.height,
      });

      if (showAboveInput) {
        placeholderStyle = _.extend({}, {
          bottom: inputStyle.height,
        });

        allSuggestions = allSuggestions.reverse();
      }

      const selected = allSuggestions[selectedIndex];

      return (
        <div className="sumome-eac-suggs" style={{...placeholderStyle}}>
          {_.uniq(allSuggestions).map((suggestion, index) => (
            <div
              key={suggestion}
              className={`sumome-eac-bubble ${selected === suggestion ? 'active' : ''}`}
              onMouseEnter={onHoverSuggestion.bind(null, index)}
              onMouseDown={onSetIgnoreBlur}
              onClick={this.onClose.bind(null, suggestion)}
              style={{ textAlign: inputStyle.textAlign, lineHeight: inputStyle.height, height: inputStyle.height }}
            >
              {suggestion}
            </div>
          ))}
        </div>
      );
    }

    render() {
      return (
        <div>
          {this.renderUnderlay()}
          {this.renderSuggestions()}
        </div>
      );
    }
  };

  return Autocomplete;
});
